/*global jQuery */
/* Contents
// ------------------------------------------------>
	// 1.  BACKGROUND INSERT - odstranene - nepotrebne
	2.  OWL CAROUSEL
	3.  MAGNIFIC POPUP
	4.  MAGNIFIC POPUP VIDEO
	// 5.  SCROLL TO - odstranene - nahradene css
	6.  NAVABR TOGGLER
    7.  PARALLAX EFFECT
    // 8.  TYPED SCRIPT - odstraneny tu aj z plugins.js - nepotrebne
    // 9.  AJAX MAILCHIMP  - odstranene - nepotrebne
    // 10. AJAX CAMPAIGN MONITOR - odstranene - nepotrebne
    // 11. AJAX CONTACT FORM - odstranene - nepotrebne

*/
$(document).ready(function(){
    "use strict";

    /* ------------------ OWL CAROUSEL ------------------ */

    $(".carousel").each(function () {
        var $Carousel = $(this);
        $Carousel.owlCarousel({
            loop: $Carousel.data('loop'),
            autoplay: $Carousel.data("autoplay"),
            margin: $Carousel.data('space'),
            nav: $Carousel.data('nav'),
            dots: $Carousel.data('dots'),
            center: $Carousel.data('center'),
            autoplaySpeed: $Carousel.data('speed'),
            dotsSpeed: $Carousel.data('speed'),
            autoplayHoverPause: $Carousel.data('hoverpause'),
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: $Carousel.data('slide-rs'),
                },
                1000: {
                    items: $Carousel.data('slide'),
                }
            }
        });
    });

    /* ------------------ MAGNIFIC POPUP ------------------ */

    var $imgPopup = $(".img-popup");
    $imgPopup.magnificPopup({
        type: "image"
    });
    $('.img-gallery-item').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    /* ------------------  MAGNIFIC POPUP VIDEO ------------------ */

    $('.popup-video,.popup-gmaps').magnificPopup({
        disableOn: 700,
        mainClass: 'mfp-fade',
        removalDelay: 0,
        preloader: false,
        fixedContentPos: false,
        type: 'iframe',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>',
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=1'
                }
            },
            srcAction: 'iframe_src',
        }
    });


    /* ------------------ NAVABR TOGGLER  ------------------ */

    var $toggler = $('.navbar-toggler');

    $toggler.on('click', function () {
        $(this).toggleClass('toggler-active');
    })

    /* ------------------  PARALLAX EFFECT ------------------ */

    siteFooter();
    $(window).resize(function () {
        siteFooter();
    });

    function siteFooter() {
        var siteContent = $('#wrapperParallax');

        var siteFooter = $('#footerParallax');
        var siteFooterHeight = siteFooter.height();

        siteContent.css({
            "margin-bottom": siteFooterHeight
        });
    };


});